const getForm = (el) => {
	if(!el) {
		return null;
	} else if(el.tagName === 'FORM') {
		return el
	} else {
		return getForm(el.parentElement)
	}
}

const initWrapper = (wrapper) => {
	const links = wrapper.getElementsByTagName('a')
	const uploads = wrapper.querySelectorAll('input[type="file"]')
	const textInputs = wrapper.querySelectorAll('input[type="text"], textarea')
	const inputs = wrapper.querySelectorAll('input, textarea')
	const form = getForm(wrapper)

	for(const link of links) {
		if(link.classList.contains('no-intercept')) {
			continue;
		}

		// onclick trigger delete
		link.addEventListener('click', (event) => {
			event.preventDefault()
			handleRequest(wrapper, link.attributes.href.value, new FormData())
			return false;
		})
	}
	for(const input of inputs) {
		// prevent submit on enter and trigger change event instead
		input.addEventListener('keydown', (event) => {
			if(event.keyCode == 13) {
				event.preventDefault()
				let changeEvent = document.createEvent('Event');
				changeEvent.initEvent('change', true, true);
				event.target.dispatchEvent(changeEvent)
			}
		}, true)

		// onchange submit only upload block
		input.addEventListener('change', (event) => {
			event.preventDefault()
			const formData = new FormData()
			for(const uploadField of uploads) {
				if(uploadField.files[0]) {
					formData.append(uploadField.attributes.name.value, uploadField.files[0])
				}
			}
			for(const textField of textInputs) {
				formData.append(textField.attributes.name.value, textField.value)
			}
			for(const hiddenField of form.querySelectorAll('input[type="hidden"]')) {
				formData.append(hiddenField.attributes.name.value, hiddenField.value)
			}

			handleRequest(wrapper, form.attributes.action.value, formData)
			return false;
		})
	}
}

const init = (selector) => {
	for(const wrapper of document.querySelectorAll(selector)){
		initWrapper(wrapper)
	}
}

const loader = (wrapper, show = false) => {
	if(show) {
		wrapper.classList.add('loading')
	} else {
		wrapper.classList.remove('loading')
	}
}

async function postData(url = '', data = {}) {
	const response = await fetch(url, {
		method: 'POST', // *GET, POST, PUT, DELETE, etc.
		mode: 'no-cors', // no-cors, *cors, same-origin
		cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
		// credentials: 'same-origin', // include, *same-origin, omit
		headers: {
			// 'Content-Type': 'multipart/form-data'
			// 'Content-Type': 'application/x-www-form-urlencoded',
		},
		redirect: 'follow', // manual, *follow, error
		referrer: 'client', // no-referrer, *client
		body:  data// body data type must match "Content-Type" header
	});
	return await response.text()
}

async function handleRequest (wrapper, url, data) {
	try {
		loader(wrapper, true)
		const id = wrapper.attributes.id.value
		const response = await postData(url, data)
		const tempNode = document.createElement('div');
		tempNode.innerHTML = response
		const tempWrapper = tempNode.querySelector('#' + id)
		const tempForm = getForm(tempWrapper)
		wrapper.innerHTML = tempWrapper.innerHTML
		getForm(tempWrapper).attributes.action.value = tempForm.attributes.action.value
		initWrapper(wrapper)
		loader(wrapper,false)
	} catch(e) {
		console.error(e)
		loader(wrapper,false)
	}
}

export default init
